import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#004E85',
        secondary: '#FF0000',
        accent: '#82B1FF',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107',
        evenRow: '#90CA',
        OddRow: '#80CB',
      },
    },
  },
  icons: {
    iconfont: 'fa',
  },
});
